export enum DialogPaneState {
    OnePane,
    TwoPane,
}
